import React from "react";
import { Paper, Box, Typography } from "@mui/material";

const SmallCard = ({ icon, title, description, sx = {} }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                width: "100%",
                height: "100%",
                minHeight: { xs: 280, md: 340 },
                bgcolor: "#1C1C1F",
                borderRadius: "3px",
                p: { xs: 4, md: 4, lg: 5 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                ...sx
            }}
        >
            <Box sx={{
                mb: 3,
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                {icon}
            </Box>

            <Typography
                variant="h5"
                sx={{
                    fontWeight: 700,
                    color: "#fff",
                    mb: 2,
                    fontSize: { xs: "1.1rem", md: "1.05rem", lg: "1.25rem" },
                }}
            >
                {title}
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    color: "rgba(255,255,255,0.6)",
                    lineHeight: 1.7,
                    fontSize: { xs: "0.95rem", md: "0.88rem", lg: "0.95rem" },
                }}
            >
                {description}
            </Typography>
        </Paper>
    );
};

export default SmallCard;